import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";

const Settings = () => {
  return <>Settings View</>;
};

export default Settings;
